module.exports = __webpack_public_path__ + "04_medium_brown.2cbdf983.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_medium_brown.png
// module id = UjKI
// module chunks = 0